import { css } from 'styled-components'

import { buttonBase } from './button-base'

export const inputBase = css`
  ${buttonBase};
  cursor: text;
`
